export const MoneyTransferData = [

    {
      id: "1",
      Date: "24 Dec 2024",
      Reference_Number: "#MT842",
      From_Account: "3298784309485",
      To_Account: "4598489498498",
      Amount: "$200",
    },
    {
      id: "2", 
      Date: "10 Dec 2024",
      Reference_Number: "#MT821",
      From_Account: "5475878970090",
      To_Account: "4494048448994",
      Amount: "$50",
    },
    {
      id: "3",
      Date: "27 Nov 2024",
      Reference_Number: "#MT847",
      From_Account: "3255465758698",
      To_Account: "6599481186468",
      Amount: "$800",
    },
    {
      id: "4",
      Date: "18 Nov 2024",
      Reference_Number: "#MT874",
      From_Account: "4353689870544",
      To_Account: "1948948498149",
      Amount: "$100",
    },
    {
      id: "5",
      Date: "06 Nov 2024",
      Reference_Number: "#MT887",
      From_Account: "4324356677889",
      To_Account: "1686941868478",
      Amount: "$700",
    },
    {
      id: "6",
      Date: "25 Oct 2024",
      Reference_Number: "#MT856",
      From_Account: "2343547586900",
      To_Account: "1658179744894",
      Amount: "$1000",
    },
    {
      id: "7",
      Date: "14 Oct 2024",
      Reference_Number: "#MT822",
      From_Account: "3453647664889",
      To_Account: "1418454896454",
      Amount: "$1200",
    },
    {
      id: "8",
      Date: "03 Oct 2024",
      Reference_Number: "#MT844",
      From_Account: "3354456565687",
      To_Account: "4418848484848",
      Amount: "$750",
    },
    {
      id: "9",
      Date: "20 Sep 2024",
      Reference_Number: "#MT832",
      From_Account: "3456565767787",
      To_Account: "6148484454564",
      Amount: "$450",
    },
    {
      id: "10",
      Date: "10 Sep 2024",
      Reference_Number: "#MT855",
      From_Account: "3434565776768",
      To_Account: "7781848484894",
      Amount: "$300",
    },
];
